<template>
  <div class="detached-route-container detchcont">
    <MessageOverlaySkeleton
      v-if="$store.getters.bc_notSupported"
      class="detchcont_message-overlay"
      :isBlurred="true"
      :isTopDown="true"
      style="--content-margin: auto; --back-from: rgba(0, 0, 0, 0.5); --back-to: rgba(0, 0, 0, 0.5)"
    >
      <div class="text-center weight_500">
        <div class="mdi mdi-message text-big"></div>
        <div
          class="text-semi-large px-8"
          v-html="$t('messages.bc_not_supported')"
        ></div>
        <div class="f-center mt-4">
          <a
            target="_blank"
            href="https://caniuse.com/broadcastchannel"
            class="link-underline link-underline_hover text-normal"
          >
            {{ $t('common.supported_browser_version_list') }}
          </a>
          <i
            class="mdi mdi-chevron-right clr-primary text-semi-large"
            style="line-height: 1"
          ></i>
        </div>
      </div>
    </MessageOverlaySkeleton>

    <TabBox
      class="flgmfslctr_tabbox pa-1 flex-1"
      :options="libOptions"
      :tab="solutionType"
      translatePath="solutions"
      style="
        --tbbox-content-clr-back: var(--clr-black-0-3);
        --tbbox-content-padding: 0.5rem;
        --tbbox-overflow-y: hidden;
        --tbbox-overflow-x: hidden;
      "
      tabsStyle="
             --height: 2.5rem;
             --height-inner: 2.75rem;
             --tab-fnt-size: 1rem;
             --tab-radius: 8px;
             --inner-flex: 1;
             --padding-inner: 0 2.5rem 0 0;
            "
      :hasNamedTabSlot="true"
      :hasScrollRight="false"
      @click="
        item => {
          item.fn()
        }
      "
    >
      <template #tab_gwiz>
        <i class="mdi mdi-bookshelf text-large mr-2"></i>
        {{ $t(`solutions.gwiz`) }}
      </template>
      <template #tab_ai_sols>
        <i class="mdi mdi-folder-plus text-large mr-2"></i>
        {{ $t(`solutions.custom`) }}
      </template>
      <template #tab_ai_reports>
        <i class="mdi mdi-folder text-large mr-2"></i>
        {{ $t(`solutions.custom_reports`) }}
      </template>
      <template #default="{ tab }">
        <GmfSelektor
          v-if="tab === 'gwiz'"
          style="width: 100%; border-radius: 4px"
          :namespace
          :instaApply="true"
          :keepHistoryTree="false"
          :hasTableKeydown="true"
          :hasLogo="true"
          :hasPreview="true"
          :routerParams="{}"
          :channelId
        />
        <SolfigrDashboard
          v-else
          ref="solform"
          class="flgmfslctr_gmf-selector"
          style="min-height: clamp(1px, 34em, var(--vh-6))"
          :instaApply="true"
          :namespace
          :tmpNamespace="''"
          :channelId
          :hasCreateNewSolutionBtn="false"
          :hasSavedSolutions="tab === 'ai_sols'"
          :hasCustomReports="tab === 'ai_reports'"
        />
      </template>
    </TabBox>
  </div>
</template>

<script>
import TabBox from '@/components/lib/TabBox'
import { SNK } from '@/helpers/helpers'

import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import GmfSelektor from '@/components/GameFormat/GmfSelektor/GmfSelektor'
import SolfigrDashboard from '@/components/ConfigureSolution/SolfigrDashboard'

export default {
  name: 'DetachedGmfSelector',
  components: {
    GmfSelektor,
    MessageOverlaySkeleton,
    SolfigrDashboard,
    TabBox,
  },
  data() {
    return {
      l_gmfs_state: '',
    }
  },
  created() {
    const { channelId } = this.$route.query
    this.channelId = channelId
    this.$store.dispatch('bc_startChannel', { channelId })
    this.$store.dispatch('bc_postMessage', {
      channelId,
      data: {
        code: 'any_update_channel',
        status: 'online',
      },
    })
  },
  mounted() {
    window.addEventListener('beforeunload', this.unregisterDetached)
  },
  methods: {
    unregisterDetached() {
      this.$store.dispatch('bc_postMessage', {
        channelId: this.channelId,
        data: {
          code: 'any_update_channel',
          status: 'closed',
        },
      })
    },
  },
  computed: {
    namespace() {
      return this.$route.query.namespace || ''
    },
    solutionType() {
      return this.$store.getters[SNK('query_solution_type', this.namespace)] === 'custom'
        ? this.$store.getters[SNK('query_gmfs_solution_tab', this.namespace)] || 'ai_sols'
        : 'gwiz'
    },
    libOptions() {
      const res = [
        {
          payload: 'gwiz',
          fn: () => {
            this.$store.dispatch(SNK('sol_switchSolType', this.namespace), {
              channelId: this.channelId,
              solType: 'gwiz',
            })
          },
        },
        {
          payload: 'ai_sols',
          fn: () => {
            this.$store.dispatch(SNK('sol_switchSolType', this.namespace), {
              channelId: this.channelId,
              solType: 'custom',
              gmfs_solution_tab: 'ai_sols',
            })
          },
        },
        this.$store.getters.user_has_flag('CR_REPORTS') && {
          payload: 'ai_reports',
          fn: () => {
            this.$store.dispatch(SNK('sol_switchSolType', this.namespace), {
              channelId: this.channelId,
              solType: 'custom',
              gmfs_solution_tab: 'ai_reports',
            })
          },
        },
      ].filter(Boolean)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.detchcont {
  font-size: clamp(14.85px, 1rem, 1rem);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex: 1;
  height: 100vh;
  width: 100vw;
  background: var(--clr-black-1);
  color: var(--clr-white-0);
  min-height: 0;
}
</style>
